import React from 'react';
import './StatChip.css';

export default function StatChip({ role }) {
  return <span className={`chip ${role}`}>{role}</span>;
}